import { useEffect, useState, useRef, useMemo } from "react";
import { usePagination } from "../hooks/usePagination";
import UniversalPagination from "../common/UniversalPagination";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";


import { API_BASE } from "../config/api";

const initialForm = {
    nombre: "",
    correo: "",
    puesto: "",
    bio: "",
};

function Experts() {
    const initialForm = {
        nombre: "",
        correo: "",
        puesto: "",
        bio: "",
    };

     const [experts, setExperts] = useState([]);
    const [loadingExperts, setLoadingExperts] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [form, setForm] = useState(initialForm);
    const [photo, setPhoto] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showValidation, setShowValidation] = useState(false);

    const [alert, setAlert] = useState({
        type: "",
        message: "",
    });

    const fileInputRef = useRef(null);

    const quillModules = useMemo(
        () => ({
            toolbar: [
                [{ header: [1, 2, 3, false] }],
                ["bold", "italic", "underline", "strike"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link", "clean"],
            ],
        }),
        []
    );

    const quillFormats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "list",
        "bullet",
        "link",
    ];

    const loadExperts = async () => {
        try {
            setLoadingExperts(true);
            setErrorMessage("");

            const response = await fetch(`${API_BASE}/api/admin/expertsList`, {
                method: "GET",
                credentials: "include",
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || "No fue posible obtener los expertos");
            }

            setExperts(data?.data || []);
        } catch (error) {
            console.error("Error al cargar expertos:", error);
            setErrorMessage(error.message || "Ocurrió un error al cargar expertos");
        } finally {
            setLoadingExperts(false);
        }
    };

    useEffect(() => {
        loadExperts();
    }, []);

    const getPlainTextFromHtml = (html = "") => {
        return html
            .replace(/<(.|\n)*?>/g, " ")
            .replace(/&nbsp;/g, " ")
            .replace(/\s+/g, " ")
            .trim();
    };

    const isNombreInvalid = !form.nombre.trim();
    const isCorreoInvalid = !form.correo.trim();
    const isPuestoInvalid = !form.puesto.trim();
    const isBioInvalid = !getPlainTextFromHtml(form.bio);
    const isPhotoInvalid = !photo;

    const resetForm = () => {
        setForm(initialForm);
        setPhoto(null);
        setShowValidation(false);

        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const handleChange = (e) => {
        const { id, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [id]: value,
        }));
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files?.[0] || null;
        setPhoto(selectedFile);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setAlert({ type: "", message: "" });
        setShowValidation(true);

        if (
            isNombreInvalid ||
            isCorreoInvalid ||
            isPuestoInvalid ||
            isBioInvalid ||
            isPhotoInvalid
        ) {
            setAlert({
                type: "info",
                message: "Todos los campos son obligatorios.",
            });
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(form.correo.trim())) {
            setAlert({
                type: "danger",
                message: "El correo electrónico no es válido.",
            });
            return;
        }

        try {
            setIsSubmitting(true);

            const formData = new FormData();
            formData.append("nombre", form.nombre.trim());
            formData.append("correo", form.correo.trim());
            formData.append("puesto", form.puesto.trim());
            formData.append("bio", form.bio);
            formData.append("photo", photo);

            const response = await fetch(`${API_BASE}/api/admin/expertsList`, {
                method: "POST",
                credentials: "include",
                body: formData,
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || "No fue posible agregar el instructor");
            }

            setAlert({
                type: "success",
                message: data?.message || "Instructor agregado correctamente.",
            });

            resetForm();
            await loadExperts();
        } catch (error) {
            console.error("Error al agregar instructor:", error);
            setAlert({
                type: "danger",
                message: error.message || "Ocurrió un error al agregar el instructor.",
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleEditInstructor = (item) => {
        console.log("Editar instructor:", item);
    };

    const handleDeleteInstructor = (item) => {
        console.log("Eliminar instructor:", item);
    };

    const {
        currentPage,
        totalPages,
        totalItems,
        paginatedItems,
        visiblePages,
        startItem,
        endItem,
        goToPage,
        goToPreviousPage,
        goToNextPage,
        resetPagination,
        hasPreviousPage,
        hasNextPage,
    } = usePagination(experts, 8, 5);

    return (
        <>
        <div class="d-flex justify-content-between align-items-center flex-wrap mb-4 gap-3">
            <div class="d-flex flex-column">
                <h3>Lista de Expertos</h3>
                <p class="text-primary mb-0">Panduit Core</p>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-header d-flex justify-content-between">
                        <div class="header-title">
                            <h4 class="card-title">Lista</h4>
                        </div>

                        <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addExpertModal">
                            <span class="btn-inner mr-5">
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-24"><path d="M12 4V20M20 12H4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                            </span>
                            Agregar
                        </button>
                    </div>

                    <div class="card-body px-0">
                        <div class="table-responsive">
                            <table
                                id="user-list-table"
                                className="table table-striped"
                                role="grid"
                                data-toggle="data-table"
                            >
                                <thead>
                                    <tr className="ligth">
                                        <th>Experto</th>
                                        <th>Email</th>
                                        <th>Estado</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {loadingExperts ? (
                                        <tr>
                                            <td colSpan="4" className="text-center py-4">
                                                Cargando instructores...
                                            </td>
                                        </tr>
                                    ) : errorMessage ? (
                                        <tr>
                                            <td colSpan="4" className="text-center py-4 text-danger">
                                                {errorMessage}
                                            </td>
                                        </tr>
                                    ) : paginatedItems.length === 0 ? (
                                        <tr>
                                            <td colSpan="4" className="text-center py-4">
                                                No hay instructores registrados.
                                            </td>
                                        </tr>
                                    ) : (
                                        paginatedItems.map((item) => (
                                            <tr key={item.Instructor_ID}>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <img
                                                            className="rounded-circle bg-primary-subtle p-1 me-3"
                                                            src={
                                                                item.Instructor_Foto ||
                                                                "../../assets/images/table/7.png"
                                                            }
                                                            alt={item.Instructor_Nombre}
                                                            loading="lazy"
                                                            style={{
                                                                width: "65px",
                                                                height: "65px",
                                                                objectFit: "cover",
                                                            }}
                                                        />
                                                        <div className="media-support-info">
                                                            <h5 className="iq-sub-label mb-0">
                                                                {item.Instructor_Nombre}
                                                            </h5>
                                                            <p className="mb-0">
                                                                {item.Instructor_Puesto || "Sin puesto"}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </td>

                                                <td>{item.Instructor_Correo || "Sin correo"}</td>

                                                <td>
                                                    {Number(item.Instructor_Activo) === 1 ? (
                                                        <span className="badge bg-success-subtle p-2 text-success">
                                                            Activo
                                                        </span>
                                                    ) : (
                                                        <span className="badge bg-danger-subtle p-2 text-danger">
                                                            Inactivo
                                                        </span>
                                                    )}
                                                </td>

                                                <td>
                                                    <div className="d-flex">
                                                        <button
                                                            type="button"
                                                            className="btn btn-icon btn-warning-subtle  ms-2"
                                                            onClick={() => handleEditInstructor(item)}
                                                        >
                                                            <span className="btn-inner">
                                                                <svg
                                                                    className="icon-32"
                                                                    width="32"
                                                                    viewBox="0 0 24 24"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        opacity="0.4"
                                                                        d="M19.9927 18.9534H14.2984C13.7429 18.9534 13.291 19.4124 13.291 19.9767C13.291 20.5422 13.7429 21.0001 14.2984 21.0001H19.9927C20.5483 21.0001 21.0001 20.5422 21.0001 19.9767C21.0001 19.4124 20.5483 18.9534 19.9927 18.9534Z"
                                                                        fill="currentColor"
                                                                    ></path>
                                                                    <path
                                                                        d="M10.309 6.90385L15.7049 11.2639C15.835 11.3682 15.8573 11.5596 15.7557 11.6929L9.35874 20.0282C8.95662 20.5431 8.36402 20.8344 7.72908 20.8452L4.23696 20.8882C4.05071 20.8903 3.88775 20.7613 3.84542 20.5764L3.05175 17.1258C2.91419 16.4915 3.05175 15.8358 3.45388 15.3306L9.88256 6.95545C9.98627 6.82108 10.1778 6.79743 10.309 6.90385Z"
                                                                        fill="currentColor"
                                                                    ></path>
                                                                    <path
                                                                        opacity="0.4"
                                                                        d="M18.1208 8.66544L17.0806 9.96401C16.9758 10.0962 16.7874 10.1177 16.6573 10.0124C15.3927 8.98901 12.1545 6.36285 11.2561 5.63509C11.1249 5.52759 11.1069 5.33625 11.2127 5.20295L12.2159 3.95706C13.126 2.78534 14.7133 2.67784 15.9938 3.69906L17.4647 4.87078C18.0679 5.34377 18.47 5.96726 18.6076 6.62299C18.7663 7.3443 18.597 8.0527 18.1208 8.66544Z"
                                                                        fill="currentColor"
                                                                    ></path>
                                                                </svg>
                                                            </span>
                                                        </button>

                                                        <button
                                                            type="button"
                                                            className="btn btn-icon btn-danger-subtle  ms-2"
                                                            onClick={() => handleDeleteInstructor(item)}
                                                        >
                                                            <span className="btn-inner">
                                                                <svg
                                                                    className="icon-32"
                                                                    width="32"
                                                                    viewBox="0 0 24 24"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        opacity="0.4"
                                                                        d="M19.643 9.48851C19.643 9.5565 19.11 16.2973 18.8056 19.1342C18.615 20.8751 17.4927 21.9311 15.8092 21.9611C14.5157 21.9901 13.2494 22.0001 12.0036 22.0001C10.6809 22.0001 9.38741 21.9901 8.13185 21.9611C6.50477 21.9221 5.38147 20.8451 5.20057 19.1342C4.88741 16.2873 4.36418 9.5565 4.35445 9.48851C4.34473 9.28351 4.41086 9.08852 4.54507 8.93053C4.67734 8.78453 4.86796 8.69653 5.06831 8.69653H18.9388C19.1382 8.69653 19.3191 8.78453 19.4621 8.93053C19.5953 9.08852 19.6624 9.28351 19.643 9.48851Z"
                                                                        fill="currentColor"
                                                                    ></path>
                                                                    <path
                                                                        d="M21 5.97686C21 5.56588 20.6761 5.24389 20.2871 5.24389H17.3714C16.7781 5.24389 16.2627 4.8219 16.1304 4.22692L15.967 3.49795C15.7385 2.61698 14.9498 2 14.0647 2H9.93624C9.0415 2 8.26054 2.61698 8.02323 3.54595L7.87054 4.22792C7.7373 4.8219 7.22185 5.24389 6.62957 5.24389H3.71385C3.32386 5.24389 3 5.56588 3 5.97686V6.35685C3 6.75783 3.32386 7.08982 3.71385 7.08982H20.2871C20.6761 7.08982 21 6.75783 21 6.35685V5.97686Z"
                                                                        fill="currentColor"
                                                                    ></path>
                                                                </svg>
                                                            </span>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <UniversalPagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        totalItems={totalItems}
                        startItem={startItem}
                        endItem={endItem}
                        visiblePages={visiblePages}
                        onPageChange={goToPage}
                        onPrevious={goToPreviousPage}
                        onNext={goToNextPage}
                        hasPreviousPage={hasPreviousPage}
                        hasNextPage={hasNextPage}
                    />
                </div>
            </div>
        </div>

        {/* Modal para agregar Experto */}
        <div
                className="modal fade"
                id="addExpertModal"
                tabIndex="-1"
                aria-labelledby="addExpertModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <form onSubmit={handleSubmit}>
                            <div className="modal-header">
                                <h5 className="modal-title" id="addExpertModalLabel">
                                    Agregar Experto
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    disabled={isSubmitting}
                                ></button>
                            </div>

                            <div className="modal-body">
                                <div className="row mb-3">
                                    <div className="col-md-4">
                                        <label className="form-label" htmlFor="nombre">
                                            Nombre Completo: <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            id="nombre"
                                            type="text"
                                            className={`form-control ${
                                                showValidation && isNombreInvalid ? "is-invalid" : ""
                                            }`}
                                            placeholder="Ingresa el nombre completo del experto"
                                            value={form.nombre}
                                            onChange={handleChange}
                                            disabled={isSubmitting}
                                        />
                                        {showValidation && isNombreInvalid && (
                                            <div className="invalid-feedback">
                                                El nombre es obligatorio.
                                            </div>
                                        )}
                                    </div>

                                    <div className="col-md-4">
                                        <label className="form-label" htmlFor="correo">
                                            Correo Electrónico: <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            id="correo"
                                            type="email"
                                            className={`form-control ${
                                                showValidation && isCorreoInvalid ? "is-invalid" : ""
                                            }`}
                                            placeholder="Ingresa el correo electrónico del experto"
                                            value={form.correo}
                                            onChange={handleChange}
                                            disabled={isSubmitting}
                                        />
                                        {showValidation && isCorreoInvalid && (
                                            <div className="invalid-feedback">
                                                El correo es obligatorio.
                                            </div>
                                        )}
                                    </div>

                                    <div className="col-md-4">
                                        <label className="form-label" htmlFor="puesto">
                                            Puesto: <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            id="puesto"
                                            type="text"
                                            className={`form-control ${
                                                showValidation && isPuestoInvalid ? "is-invalid" : ""
                                            }`}
                                            placeholder="Ingresa el puesto del experto"
                                            value={form.puesto}
                                            onChange={handleChange}
                                            disabled={isSubmitting}
                                        />
                                        {showValidation && isPuestoInvalid && (
                                            <div className="invalid-feedback">
                                                El puesto es obligatorio.
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col">
                                        <label className="form-label">
                                            Biografía: <span className="text-danger">*</span>
                                        </label>

                                        <div className={showValidation && isBioInvalid ? "border border-danger rounded" : ""}>
                                            <ReactQuill
                                                theme="snow"
                                                value={form.bio}
                                                onChange={(value) =>
                                                    setForm((prev) => ({
                                                        ...prev,
                                                        bio: value,
                                                    }))
                                                }
                                                modules={quillModules}
                                                formats={quillFormats}
                                                readOnly={isSubmitting}
                                                placeholder="Escribe la biografía del instructor..."
                                            />
                                        </div>

                                        {showValidation && isBioInvalid && (
                                            <div className="text-danger mt-1 small">
                                                La biografía es obligatoria.
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col">
                                        <label className="form-label" htmlFor="customFile1">
                                            Selecciona una imagen: <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            ref={fileInputRef}
                                            className={`form-control ${
                                                showValidation && isPhotoInvalid ? "is-invalid" : ""
                                            }`}
                                            type="file"
                                            id="customFile1"
                                            accept=".jpg,.jpeg,.png,.webp"
                                            onChange={handleFileChange}
                                            disabled={isSubmitting}
                                        />
                                        {showValidation && isPhotoInvalid && (
                                            <div className="invalid-feedback">
                                                La imagen es obligatoria.
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {alert.message && (
                                <div
                                    className={`mb-3 alert alert-${
                                        alert.type === "danger" ? "danger" : alert.type
                                    } alert-dismissible fade show`}
                                    role="alert"
                                >
                                    <span>{alert.message}</span>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setAlert({ type: "", message: "" })}
                                        aria-label="Close"
                                    ></button>
                                </div>
                            )}

                            {errorMessage && (
                                <div className="alert alert-danger" role="alert">
                                    {errorMessage}
                                </div>
                            )}
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal"
                                    disabled={isSubmitting}
                                >
                                    Cerrar
                                </button>

                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? "Agregando..." : "Agregar"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Experts